/**
 * Payload de `POST /suitability-test` de wio.pdf.
 *
 * Es DELIBERADAMENTE agnóstico de compañía: `answers` y `result` viajan opacos y
 * el motor no lee nada de dentro. Si un informe necesita un dato derivado del
 * `result`, lo saca su resolver en wio.pdf (`companies/{compañía}/{versión}`), que
 * sí conoce la forma — no se añade un campo aquí.
 */
export interface PdfDetailInput {
  clientId: string;
  clientName: string;
  questionnaireVersion: string;
  language: string;
  createdAt: string;
  validUntil: string;
  /** Id del Risk en wio.api; wio.pdf marca con él el segmento activo del medidor. */
  riskProfileId: number;
  answers: Record<string, unknown>;
  /** Resultado específico de la compañía. Opaco: viaja tal cual. */
  result: unknown;
}

export const buildPdfDetail = (
  input: PdfDetailInput,
): Record<string, unknown> => ({
  // testId no lo usa wio.pdf (el resolver lo ignora); el PDF se genera antes de
  // persistir el test, así que todavía no hay id.
  testId: '',
  ...input,
});
